<template>
  <el-row class="container">
    <el-col :span="4">LOGO</el-col>
    <el-col :span="16">客户工程师接待系统</el-col>
    <el-col :span="4">
      你好，{{this.realName}} <span @click="logout" class="logout">注销</span>
    </el-col>
  </el-row>
</template>

<script>
export default {
  name: 'HelloWorld',
  components: {
  },
  data () {
    return {
      realName: '',
      loginForm: {
          uname: '',
          passwd: ''
      },
      rules2: {
          uname: [{required: true, message: '请输入用户名!', trigger: 'blur'}],
          passwd: [{required: true, message: '请输入密码!', trigger: 'blur'}]
      },
      checked: false
    }
  },
  mounted () {
    var user = localStorage.getItem('user')
    var u = JSON.parse(user)
    this.realName = u.realName
  },
  methods: {
    logout () {
      localStorage.removeItem('user')
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.logout {
    color: #2b1fe0;
}
</style>



// WEBPACK FOOTER //
// src/components/PageHeader.vue